export default __webpack_public_path__ + "static/media/img005.d83c6af0.png";